import _ from 'lodash';
import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { RESET } from 'action-creators/generic';
import {
  HOTELS_SEARCH_REQUEST,
  HOTELS_SEARCH_SUCCESSFUL,
  HOTELS_SEARCH_FAILURE,
  HOTELS_RESULT_SUCCESSFUL,
  HOTELS_RESULT_REQUEST,
  HOTELS_RESULT_FAILURE,
  HOTELS_CHANGE_RESULT_PAGINATION,
  HOTELS_PAGINATION_CLEAR,
  HOTELS_CLEAR,
  HOTELS_FILTER_CLEAR,
  HOTELS_SET_TRAVELER,
  HOTELS_SEARCH_PARAMETERS,
} from 'action-creators/hotels';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { HotelFilter } from 'models/hotelFilter';
import { TravelHotelContentLocationRequest } from 'models/hotelLocation';
import { HotelsSearchResponse } from 'models/hotelsSearch';
import { TravelArrangerUsersAllowed } from 'services/userService';

export interface HotelsState {
  destinationPoint?: TravelHotelContentLocationRequest;
  checkInDate?: Date;
  checkOutDate?: Date;
  travelers?: TravelArrangerUsersAllowed[];
  isLoadingSearch: boolean;
  isLoadingResults: boolean;
  isEnd: boolean;
  filters?: HotelFilter;
  search?: HotelsSearchResponse;
  error?: string;
  branchCompany?: GetAllBillingCompanyResponse;
  resultCountLowerBound?: number;
  resultCountUpperBound?: number;
}

const initialState = {
  isLoadingSearch: false,
  isLoadingResults: false,
  isEnd: false,
};

const reducer: Reducer<HotelsState> = (state = initialState, action) => {
  switch (action.type) {
    case HOTELS_SEARCH_REQUEST:
      return {
        ...state,
        isLoadingSearch: true,
        isEnd: false,
        filters: undefined,
        search: undefined,
        ...action.payload,
      };
    case HOTELS_SEARCH_PARAMETERS:
      return {
        ...state,
        isLoadingSearch: false,
        isEnd: false,
        filters: undefined,
        search: undefined,
        ...action.payload,
      };
    case HOTELS_SEARCH_SUCCESSFUL:
      return {
        ...state,
        isLoadingSearch: false,
        search: {
          ...action.payload,
          results: [],
        },
      };
    case HOTELS_CHANGE_RESULT_PAGINATION:
      return {
        ...state,
        resultCountLowerBound: action.payload.countLowerBound,
        resultCountUpperBound: action.payload.countUpperBound,
      };
    case HOTELS_PAGINATION_CLEAR:
      return {
        ...state,
        resultCountLowerBound: 0,
        resultCountUpperBound: 10,
      };
    case HOTELS_SEARCH_FAILURE:
      return {
        ...state,
        error: action.payload,
        search: undefined,
        isLoadingSearch: false,
      };
    case HOTELS_RESULT_REQUEST:
      return {
        ...state,
        isLoadingResults: true,
        isEnd: false,
        filters: action.payload.filters || state.filters,
        search: {
          ...state.search,
          results:
            !action.payload.filters || _.isEqual(state.filters, action.payload.filters) ? state.search?.results : [],
        },
      };
    case HOTELS_RESULT_SUCCESSFUL:
      return {
        ...state,
        isLoadingResults: false,
        isEnd: action.payload.length === 0,
        search: {
          ...state.search,
          results: _.unionWith([...(state.search?.results || [])], [...(action.payload || [])], _.isEqual),
        },
      };
    case HOTELS_RESULT_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoadingResults: false,
      };
    case HOTELS_FILTER_CLEAR:
      return { ...state, filters: undefined };
    case HOTELS_CLEAR:
      return {
        ...state,
        search: undefined,
        isLoadingSearch: false,
        isLoadingResults: false,
        destinationPoint: undefined,
        checkInDate: undefined,
        checkOutDate: undefined,
        branchCompany: undefined,
      };
    case HOTELS_SET_TRAVELER:
      return {
        ...state,
        traveler: action.payload || state.travelers,
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'hotels',
  blacklist: ['isLoadingSearch', 'isLoadingResults', 'error','resultCountLowerBound','resultCountUpperBound'],
};

export default persistReducer(persistConfig, reducer);
